import axios from 'axios'

export const DEFAULT_ALLOWED_EXTENSIONS = 'jpg,jpeg,png,gif,bmp,webp,pdf,doc,docx,xls,xlsx,ppt,pptx,txt,glb,mp4,mov'

const normalizeExtension = (value) => String(value || '').trim().toLowerCase().replace(/^\./, '')

export const normalizeAllowedExtensions = (value) => {
  const text = String(value || '').trim()
  return text || DEFAULT_ALLOWED_EXTENSIONS
}

export const parseAllowedExtensions = (value) => {
  const text = normalizeAllowedExtensions(value)
  if (text === '*') return ['*']
  return [...new Set(text.split(',').map(normalizeExtension).filter(Boolean))]
}

export const getFileExtension = (file) => {
  const name = String(file?.name || '').trim()
  const dot = name.lastIndexOf('.')
  return dot >= 0 && dot < name.length - 1 ? normalizeExtension(name.slice(dot + 1)) : ''
}

export const isAllowedUploadFile = (file, value) => {
  const extensions = parseAllowedExtensions(value)
  if (extensions.includes('*')) return true
  const extension = getFileExtension(file)
  return !!extension && extensions.includes(extension)
}

export const allowedExtensionsMessage = (value) => `请上传${normalizeAllowedExtensions(value)}格式的文件`

export const buildUploadAccept = (value, filterExtensions = null) => {
  let extensions = parseAllowedExtensions(value)
  if (extensions.includes('*')) return '*'
  if (Array.isArray(filterExtensions) && filterExtensions.length) {
    const filterSet = new Set(filterExtensions.map(normalizeExtension))
    extensions = extensions.filter((extension) => filterSet.has(extension))
  }
  return extensions.map((extension) => `.${extension}`).join(',')
}

export const loadAllowedExtensions = async () => {
  try {
    const res = await axios.get('/api/configs/value/site.allowedExtensions')
    return normalizeAllowedExtensions(res?.data?.data)
  } catch {
    return DEFAULT_ALLOWED_EXTENSIONS
  }
}
